export class AdminPageDefinition {
    constructor(private titleValue: string | (() => string) = "", private categoryValue: string | (() => string) = "", public icon = "", public routerLink: string[] = []) {
    }

    get title(): string {
        return typeof this.titleValue == "function" ? this.titleValue() : this.titleValue;
    }

    set title(value: string) {
        this.titleValue = value;
    }

    get category(): string {
        return typeof this.categoryValue == "function" ? this.categoryValue() : this.categoryValue;
    }

    set category(value: string) {
        this.categoryValue = value;
    }
}
